import { render } from "./CopyTemplateComponent.vue?vue&type=template&id=0d3f402c&scoped=true"
import script from "./CopyTemplateComponent.vue?vue&type=script&lang=js"
export * from "./CopyTemplateComponent.vue?vue&type=script&lang=js"

import "./CopyTemplateComponent.vue?vue&type=style&index=0&id=0d3f402c&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d3f402c"]])

export default __exports__